import React, { useState, useEffect } from "react";

const DecryptText = ({
  text,
  duration = 5000, // total duration for character switching (random mode)
  speed = 50, // milliseconds between character reveals (sequential mode)
  mode = "random", // "random" or "sequential"
  randomChars = "!@#$%^&*()_+-=[]{}|;:,.<>?~`0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
  className = "",
}) => {
  const [displayText, setDisplayText] = useState("");
  const [isDecrypting, setIsDecrypting] = useState(false);
  const [resolvedChars, setResolvedChars] = useState(new Set());

  useEffect(() => {
    if (!text) return;

    // Initialize with random characters, but keep spaces
    const randomText = text
      .split("")
      .map((char) =>
        char === " "
          ? " "
          : randomChars[Math.floor(Math.random() * randomChars.length)]
      )
      .join("");

    setDisplayText(randomText);
    setIsDecrypting(true);
    setResolvedChars(new Set());

    // Create timers for character resolution based on mode
    const timers = [];
    const textArray = text.split("");

    for (let i = 0; i < textArray.length; i++) {
      // Skip spaces - they don't need to be resolved
      if (textArray[i] === " ") {
        setResolvedChars((prev) => new Set([...prev, i]));
        continue;
      }

      let delay;
      if (mode === "sequential") {
        // Sequential: resolve characters from left to right with fixed speed
        const charIndex = textArray
          .slice(0, i)
          .filter((char) => char !== " ").length;
        delay = charIndex * speed;
      } else {
        // Random: random delay between 0 and duration
        delay = Math.random() * duration;
      }

      const timer = setTimeout(() => {
        setResolvedChars((prev) => new Set([...prev, i]));
      }, delay);

      timers.push(timer);
    }

    // Clean up all timers
    return () => {
      timers.forEach((timer) => clearTimeout(timer));
    };
  }, [text, duration, randomChars]);

  // Update display text as characters get resolved
  useEffect(() => {
    if (!text || resolvedChars.size === 0) return;

    setDisplayText((prevText) => {
      const newText = prevText.split("");
      resolvedChars.forEach((index) => {
        if (index < text.length) {
          newText[index] = text[index];
        }
      });
      return newText.join("");
    });

    // Check if all characters are resolved
    if (resolvedChars.size === text.length) {
      setIsDecrypting(false);
    }
  }, [resolvedChars, text]);

  return (
    <div className={`decrypt-text ${className}`}>
      {displayText.split("").map((char, index) => (
        <span
          key={index}
          className={
            resolvedChars.has(index) ? "decrypt-resolved" : "decrypt-random"
          }
        >
          {char}
        </span>
      ))}
    </div>
  );
};

export default DecryptText;
